import React, {createContext, ReactNode, useState} from "react";
import {UserInformation} from "../types";

export interface AuthInfo {
    token: string;
    userInformation: UserInformation | null;
}

interface AuthContextType {
    info: AuthInfo | null;
}

export const AuthContext = createContext<AuthContextType>({
    info: null
});

interface TokenProviderProps {
    children: ReactNode;
}

export const TokenProvider: React.FC<TokenProviderProps> = ({children}) => {
    const [info] = useState<AuthInfo | null>(null);
    return (<AuthContext.Provider value={{info}}>
        {children}
    </AuthContext.Provider>);
};
